import { MessageLog } from './messageLogType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class MessageLogApi {
    static async getMessageLogByCustomer(customerId: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/customers/${customerId}/message_logs`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });
            
            const responseBody = await response.json();
            
            if (response.status === 200) {
                // The API now returns a structured response with estimate, invoice, and payment_statement categories
                // We'll return it directly as the component will handle the structure
                return responseBody;
            }
            else if (response.status === 404) { 
                // Return empty response structure if no data found
                return {
                    estimate: {
                        email: { data: [] },
                        sms: { data: [] }
                    },
                    invoice: {
                        email: { data: [] },
                        sms: { data: [] }
                    },
                    payment_statement: {
                        email: { data: [] },
                        sms: { data: [] }
                    }
                };
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error && responseBody.error.includes('duplicate')) {
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(`${responseBody.error || 'Unknown error'} status ${response.status}`);
                }
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get the message logs: ${error.message}`);
            } else {
                throw new Error('Failed to get the message logs: An unknown error occurred.');
            }
        }
    }
}

export default MessageLogApi;